
/* styles */
require("!!vue-style-loader!css-loader!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4d12da91&scoped=true!sass-loader!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./SnapVerticalPhoto.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./SnapVerticalPhoto.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4d12da91!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./SnapVerticalPhoto.vue"),
  /* scopeId */
  "data-v-4d12da91",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/page/partials/Order/Catalog/SnapVerticalPhoto.vue
// module id = 634
// module chunks = 0